import { AddressType, type PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { getFormattedAddress } from "Utils/AddressUtils";
import { formatPhone } from "Utils/PhoneUtils";
import { ValueItems } from "Components/Shared/ValuesBox/ValueItems";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import { ResendAccessButton } from "Components/Hunter/Merchants/Detail/Tabs/Merchant/ResendAccessButton";
import { CancelAccessButton } from "Components/Hunter/Merchants/Detail/Tabs/Merchant/CancelAccessButton";
import { ActivateMerchantButton } from "Components/Hunter/Merchants/Detail/Tabs/Merchant/ActivateMerchantButton";
import { Box } from "@mui/material";

const RESOURCES = Resources.Common;

type Props = {
  partyData: PartyDto;
  merchantPublicID: string;
  merchantUserLogin: string;
  canResendAccess?: boolean;
  canActivate?: boolean;
};

export const MerchantBasicInfoSection = ({
  partyData,
  merchantUserLogin,
  merchantPublicID,
  canResendAccess,
  canActivate,
}: Props) => {
  const { t } = useResource();
  const { type, addresses, companyName, companyNumber, phone, email } =
    partyData;

  const headquartersAddress = addresses.find(
    ({ type }) => type === AddressType.Headquarters,
  );

  const addressValue = headquartersAddress
    ? getFormattedAddress(headquartersAddress)
    : "-";

  return (
    <ValuesBox title={t(Resources.Components.Account.GeneralInformation)}>
      <ValueItems
        values={[
          { label: t(RESOURCES.CompanyName), value: companyName },
          { label: t(RESOURCES.CompanyNumber), value: companyNumber },
          {
            label: t(RESOURCES.PartyTypeLabel),
            value: t(Resources.Form.PartyType[type]),
          },
          {
            label: t(RESOURCES.Address.Type[AddressType.Headquarters]),
            value: addressValue,
          },
          { label: t(RESOURCES.Phone), value: formatPhone(phone) },
          { label: t(RESOURCES.Email), value: email },
          { label: t(RESOURCES.Login), value: merchantUserLogin },
        ]}
      />
      {canResendAccess && (
        <Box
          display="flex"
          gap={1}
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
        >
          <ResendAccessButton
            merchantUserLogin={merchantUserLogin}
            merchantPublicID={merchantPublicID}
          />
          <CancelAccessButton
            merchantUserLogin={merchantUserLogin}
            merchantPublicID={merchantPublicID}
          />
        </Box>
      )}
      {canActivate && (
        <Box display="flex" justifyContent="center">
          <ActivateMerchantButton merchantPublicID={merchantPublicID} />
        </Box>
      )}
    </ValuesBox>
  );
};
